module.exports = __webpack_public_path__ + "static/ingenieria-2735aca7221ae53949756e27a5b68aac.jpg";